import { useNavigate } from 'react-router';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { useI18n } from '@/i18n/useI18n';

interface AuthTabsProps {
  active: 'login' | 'register';
}

export function AuthTabs({ active }: AuthTabsProps) {
  const navigate = useNavigate();
  const { t } = useI18n();

  return (
    <Tabs
      value={active}
      onValueChange={(value) => navigate(value === 'login' ? '/login' : '/register')}
      className="w-full"
    >
      <TabsList className="w-full">
        <TabsTrigger value="login">{t('auth.tabLogin')}</TabsTrigger>
        <TabsTrigger value="register">{t('auth.tabRegister')}</TabsTrigger>
      </TabsList>
    </Tabs>
  );
}
